import { InjectionToken } from '@rxdi/core';

export interface FirebaseSocialConfig {
  apiKey: string;
  authDomain: string;
  appId: string;
  projectId: string;
  databaseURL?: string;
  storageBucket?: string;
  messagingSenderId?: string;
  measurmentId?: string;
}

export type SetProviderType<T> = (p: T) => T;

export type FacebookProvider = firebase.auth.FacebookAuthProvider;
export type TwitterProvider = firebase.auth.TwitterAuthProvider;
export type GithubProvider = firebase.auth.GithubAuthProvider;
export type GoogleProvider = firebase.auth.GoogleAuthProvider;

export type ProvidersType = 'github' | 'facebook' | 'twitter' | 'google';

export const FirestoreDB = new InjectionToken<firebase.firestore.Firestore>('firestore-database');
export type FirestoreDB = firebase.firestore.Firestore;
export const FirebaseDB = new InjectionToken<firebase.database.Database>('firebase-database');

export type FirebaseDB = firebase.database.Database;
